import { render, staticRenderFns } from "./event-manage.vue?vue&type=template&id=4ea9a931&scoped=true&"
import script from "./event-manage.vue?vue&type=script&lang=js&"
export * from "./event-manage.vue?vue&type=script&lang=js&"
import style0 from "./event-manage.vue?vue&type=style&index=0&id=4ea9a931&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea9a931",
  null
  
)

export default component.exports